import { LoadingSpinner } from "../../../core/components/LoadingSpinner";
import { Field, useField } from 'formik';
import { renderProductIcon } from 'legoland-sdk';
import { UserRole, isUserProductFallback, useMeDetailsQuery } from 'legoland-sdk/dist/experimental';
import { Alert, Box, Checkbox, FormGroup } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContractProductsField = ({
  contract,
  name,
  userRole,
  ...stylingProps
}) => {
  const meDetailsQuery = useMeDetailsQuery();
  const products = userRole === UserRole.Distributor ? meDetailsQuery.data?.meDetails?.products.filter(product => product.resell.status === 'ALLOWED') : meDetailsQuery.data?.meDetails?.products;
  const [field, meta] = useField(name);
  return meDetailsQuery.isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : meDetailsQuery.isError ? /*#__PURE__*/_jsx(Alert, {
    title: "Could not fetch available products",
    variant: "danger"
  }) : /*#__PURE__*/_jsx(FormGroup, {
    error: meta.touched && meta.error,
    label: false,
    ...stylingProps,
    children: /*#__PURE__*/_jsx(Box, {
      $display: "flex",
      $mt: "1sp",
      ...(userRole !== UserRole.Distributor ? {
        $justifyContent: 'space-between'
      } : {
        $justifyContent: 'start'
      }),
      children: products.filter(product => userRole === UserRole.Distributor ? product.id !== 'rer' : true).map(product => !isUserProductFallback(product) && /*#__PURE__*/_jsxs(Box, {
        $alignItems: "center",
        $display: "flex",
        as: "label",
        $mr: "3sp",
        children: [/*#__PURE__*/_jsx(Field, {
          $display: "flex",
          $mr: "1sp",
          as: Checkbox,
          label: false,
          name: name,
          value: product.id,
          checked: field.value.includes(product.id)
        }), ' ', renderProductIcon(product.id)]
      }, product.id))
    })
  });
};